import { styled, Flex } from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';

export const styles = {
  Wrapper: styled(Flex, {
    maxWidth: 'calc($9 * 10)',
  }),

  Subtitle: styled(ResponsiveFloraTypography, {
    textAlign: 'center',
  }),
};

export default styles;
